import React, { useState, useEffect } from "react";
import Header from "../../components/Header/Header";
import PreLoginHeader from "../../components/PreLoginHeader/PreLoginHeader";
import Footer from "../../components/Footer/Footer";
import "./LabTestsPage.scss";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { IoExpandOutline } from "react-icons/io5";
import { LiaCompressArrowsAltSolid } from "react-icons/lia";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import { deleteData, fetchData } from "../../services/apiService";
import useAlertUtils from "../../utils/common.utils";

function TestDetailView() {
  const token = localStorage.getItem("token");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModelOpen, setIsDeleteModelOpen] = useState(false);
  const [testDetail, setTestDetail] = useState(null);
  const { alertError, alertSuccess } = useAlertUtils();

  const navigate = useNavigate();

  const { id } = useParams();

  const getTestDetails = async (id) => {
    try {
      const data = await fetchData(`api/test/get-labTest-detail/${id}`);

      if (data.success === true) {
        setTestDetail(data.data);
      } else {
        alertError("Error Fetching User Data");
      }
    } catch (error) {
      alertError("Error Fetching User Data");
    }
  };

  useEffect(() => {
    getTestDetails(id);
  }, []);

  const handleDeleteTest = async (id) => {
    try {
      const res = await deleteData(`/api/test/delete-labTest/${id}`);
      if (res.success === true) {
        alertSuccess("Test Deleted Successfully");
        setIsDeleteModelOpen(false);
        navigate("/app/lab-tests");
      }
    } catch (error) {
      alertError("Error Deleting Data");
    }
  };

  return (
    <div className="test-detail-page">
      {token ? <Header /> : <PreLoginHeader />}

      <div className="test-detail-wrapper">
        <div className="test-detail-header">
          <h1 className="test-detail-title">Test Details</h1>
          <div className="test-detail-actions">
            <button
              className="test-detail-edit-btn"
              onClick={() => {
                navigate(`/app/edit-test/${id}`);
              }}
            >
              Edit
            </button>
            <button
              onClick={() => {
                setIsDeleteModelOpen(true);
              }}
              className="test-detail-delete-btn"
            >
              Delete
            </button>
          </div>
        </div>

        <div className="test-detail-body">
          <div className="test-detail-info">
            <div className="test-detail-row">
              <label>Test name</label>
              <div>{testDetail?.testName}</div>
            </div>
            <div className="test-detail-row">
              <label>Laboratory name</label>
              <div>{testDetail?.laboratoryName}</div>
            </div>
            <div className="test-detail-row">
              <label>Laboratory location</label>
              <div>{testDetail?.laboratoryLocation}</div>
            </div>
            <div className="test-detail-row">
              <label>Added Date</label>
              <div>
                {new Date(testDetail?.createdAt).toLocaleDateString("en-US", {
                  weekday: "long",
                  month: "long",
                  day: "numeric",
                })}
              </div>
            </div>
          </div>

          <div className="test-detail-preview">
            <div
              onClick={() => {
                setIsModalOpen(true);
              }}
              className="expand-button"
            >
              <IoExpandOutline size={45} color="white" />
            </div>
            {testDetail?.testFileUrl && (
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                <Viewer fileUrl={testDetail.testFileUrl} />
              </Worker>
            )}
          </div>
        </div>
        <div className="test-detail-cancel">
          <button
            onClick={() => {
              navigate("/app/lab-tests");
            }}
            className="test-detail-cancel-btn"
          >
            Cancel
          </button>
        </div>
      </div>

      <Footer />

      {isModalOpen && (
        <div
          className="pdf-modal-overlay"
          onClick={() => setIsModalOpen(false)}
        >
          <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Full PDF</h2>
              <div
                className="close-button"
                onClick={() => setIsModalOpen(false)}
              >
                <LiaCompressArrowsAltSolid size={45} color="white" />
              </div>
            </div>
            <div className="modal-body">
              {testDetail?.testFileUrl && (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <Viewer fileUrl={testDetail?.testFileUrl} />
                </Worker>
              )}
            </div>
          </div>
        </div>
      )}
      {isDeleteModelOpen && (
        <div
          className="delete-modal-overlay"
          onClick={() => setIsDeleteModelOpen(false)}
        >
          <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
            <div className="delete-modal-header">
              <div onClick={() => setIsDeleteModelOpen(false)}>
                <IoCloseCircleOutline cursor="pointer" size={45} color="red" />
              </div>
            </div>
            <div className="delete-modal-body">
              <h2>Delete Test</h2>
              <p>
                Are you sure you want to delete{" "}
                <span style={{ color: "red" }}>{testDetail.testName}</span>{" "}
                laboratory test?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginTop: "40px",
                }}
              >
                <button
                  onClick={() => {
                    setIsDeleteModelOpen(false);
                  }}
                >
                  No
                </button>
                <button
                  onClick={() => {
                    handleDeleteTest(testDetail.id);
                  }}
                  className="btn btn-primary add_kit"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TestDetailView;
